import { Select, SelectOption } from "@clockwise/design-system";
import { ConferencingType } from "@clockwise/schema";
import { MeetLogo } from "@clockwise/web-commons/src/components/svgs/MeetLogo";
import { TeamsLogo } from "@clockwise/web-commons/src/components/svgs/TeamsLogo";
import { ZoomLogo } from "@clockwise/web-commons/src/components/svgs/ZoomLogo";
import {
  DeleteRounded as RemoveIcon,
  SvgIconComponent,
  VideocamRounded as VideoConferencingIcon,
} from "@material-ui/icons";
import React from "react";

type Actions = "Join" | "Remove";

type Props = {
  disabled: boolean;
  onJoin: () => void;
  onRemove: () => void;
  selected: ConferencingType;
  videoLink?: string;
};

const SelectionDetails: Record<ConferencingType, [string, SvgIconComponent]> = {
  MEET: ["Meet Meeting", MeetLogo],
  TEAMS_FOR_BUSINESS: ["Teams Meeting", TeamsLogo],
  ZOOM: ["Zoom Meeting", ZoomLogo],
  AROUND: ["Around Meeting", VideoConferencingIcon],
  OTHER: ["Video Meeting", VideoConferencingIcon],
};

export const SelectVideoConfAction = ({
  disabled,
  onJoin,
  onRemove,
  selected,
  videoLink,
}: Props) => {
  const value = "" as const; // DEV NOTE: always keep select in "unselected" state

  const [text, Icon] = SelectionDetails[selected];

  const handleAction = (option: Actions) => {
    switch (option) {
      case "Join":
        onJoin();
        break;
      case "Remove":
        onRemove();
        break;
      default:
        break;
    }
  };

  return (
    <Select disabled={disabled} onChange={handleAction} size="small" value={value} variant="inline">
      <SelectOption value="" icon={Icon}>
        {text}
      </SelectOption>
      {Boolean(videoLink) && (
        <SelectOption
          value={"Join" as Actions}
          icon={VideoConferencingIcon}
          iconProps={{ className: "cw-text-muted" }}
        >
          Join
        </SelectOption>
      )}
      <SelectOption
        value={"Remove" as Actions}
        icon={RemoveIcon}
        iconProps={{ className: "cw-text-destructive" }}
      >
        Remove
      </SelectOption>
    </Select>
  );
};
